import { render } from "./FlowForm.vue?vue&type=template&id=3b742031"
import script from "./FlowForm.vue?vue&type=script&lang=js"
export * from "./FlowForm.vue?vue&type=script&lang=js"

import "./FlowForm.vue?vue&type=style&index=0&id=3b742031&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__